// src/hooks/useBookings.js
import {useCallback, useEffect, useState} from 'react';
import axios from 'axios';
import {DOMEN_BASE} from "../assets/config/constants";

export const useBookings = () => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchBookings = useCallback(async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${DOMEN_BASE}/api/getTodayCheckouts.php`);
            setBookings(res.data || []);
        } catch (err) {
            console.error(err);
            setBookings([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchBookings();
    }, [fetchBookings]);

    return {bookings, loading, refetch: fetchBookings};
};
